import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.pick.pickFinishedDialog.title',
    defaultMessage: 'Finished picking',
    description: 'Title of the pick finished dialog',
  },
  message: {
    id: 'pages.pick.pickFinishedDialog.message',
    defaultMessage: 'You have finished picking',
    description: 'Message of the pick finished dialog',
  },
  actions: {
    continue: {
      id: 'actions.continue',
      defaultMessage: 'Continue',
      description: 'Label of the continue action of the pick finished dialog',
    },
  },
};

export default defineMessages(translations);
